<template>
    <div class="expert-panel-event">
        <main>
            <Breadcrumbs :items="breadcrumbs"/>
            <div class="expert-panel-event__header">
                <h1>{{ name }}</h1>
                <div class="expert-panel-event__till">
                    <div>До окончания оценки</div>
                    <div>{{ dateEnd }}</div>
                </div>
            </div>
            <ExpertPanelTabs>
                <ExpertPanelTab :title="`Ожидание (${itemsNew.total})`">
                    <ExpertPanelTableNew
                        v-loading="itemsNewLoading"
                        :rows="itemsNew.items"
                        :current-page="currentPage.need_check"
                        :current-page-size="currentPageSize.need_check"
                        :total="itemsNew.total"
                        :review="event"
                        :filter="filter.need_check"
                        @update-current-page="loadData('need_check', $event, currentPageSize.need_check, filter.need_check)"
                        @update-page-size="loadData('need_check', 1, $event, filter.need_check)"
                        @update-filter="loadData('need_check', 1, currentPageSize.need_check, $event)"
                    />
                </ExpertPanelTab>
                <ExpertPanelTab :title="`В работе (${itemsChecking.total})`">
                    <ExpertPanelTableChecking
                        v-loading="itemsCheckingLoading"
                        :rows="itemsChecking.items"
                        :current-page="currentPage.in_check"
                        :current-page-size="currentPageSize.in_check"
                        :total="itemsChecking.total"
                        :review="event"
                        :filter="filter.in_check"
                        @update-current-page="loadData('in_check', $event, currentPageSize.in_check, filter.in_check)"
                        @update-page-size="loadData('in_check', 1, $event, filter.in_check)"
                        @update-filter="loadData('in_check', 1, currentPageSize.in_check, $event)"
                    />
                </ExpertPanelTab>
                <ExpertPanelTab :title="`Проверено (${itemsCompleted.total})`">
                    <ExpertPanelTableCompleted
                        v-loading="itemsCompletedLoading"
                        :rows="itemsCompleted.items"
                        :current-page="currentPage.completed"
                        :current-page-size="currentPageSize.completed"
                        :total="itemsCompleted.total"
                        :is-super="isSuper"
                        :review="event"
                        :need-feedback="itemsCompleted.needFeedback"
                        :filter="filter.completed"
                        @update-current-page="loadData('completed', $event, currentPageSize.completed, filter.completed)"
                        @update-page-size="loadData('completed', 1, $event, filter.completed)"
                        @update-filter="loadData('completed', 1, currentPageSize.completed, $event)"
                        @reload="reloadData()"
                    />
                </ExpertPanelTab>
                <ExpertPanelTab v-if="isSuper" :title="`Отправлено (${itemsPosted.total})`">
                    <ExpertPanelTablePosted
                        v-loading="itemsPostedLoading"
                        :rows="itemsPosted.items"
                        :current-page="currentPage.posted"
                        :current-page-size="currentPageSize.posted"
                        :total="itemsPosted.total"
                        :is-anonymously="event && event.isAnonymous"
                        :review="event"
                        :filter="filter.posted"
                        @update-current-page="loadData('posted', $event, currentPageSize.posted, filter.posted)"
                        @update-page-size="loadData('posted', 1, $event, filter.posted)"
                        @update-filter="loadData('posted', 1, currentPageSize.posted, $event)"
                    />
                </ExpertPanelTab>
            </ExpertPanelTabs>
        </main>
    </div>
</template>

<script>
import Breadcrumbs from '@/components/UI/Breadcrumbs';
import ExpertPanelTabs from "@/components/expert-panel-new/ExpertPanelTabs.vue";
import ExpertPanelTab from "@/components/expert-panel-new/ExpertPanelTab.vue";
import ExpertPanelTableNew from "@/components/expert-panel-new/tables/ExpertPanelTableNew.vue";
import ExpertPanelTableChecking from "@/components/expert-panel-new/tables/ExpertPanelTableChecking.vue";
import ExpertPanelTableCompleted from "@/components/expert-panel-new/tables/ExpertPanelTableCompleted.vue";
import {getFio} from "@/tools/tools";
import {mapGetters} from "vuex";
import ExpertPanelTablePosted from "@/components/expert-panel-new/tables/ExpertPanelTablePosted.vue";
import moment from "moment/moment";
import declinationOfNumber from "@/tools/declinationOfNumber";
import {limitSessions} from "@/stores/examination";

export default {
    name: 'ExpertPanelEvent',
    components: {
        ExpertPanelTablePosted,
        ExpertPanelTableCompleted,
        ExpertPanelTableChecking,
        ExpertPanelTableNew,
        ExpertPanelTab,
        ExpertPanelTabs,
        Breadcrumbs,
    },
    data() {
        const initFilter = {
            userId: '',
            score: null,
        };
        return {
            currentTab: 0,
            currentPage: {
                need_check: 1,
                in_check: 1,
                completed: 1,
                posted: 1,
            },
            currentPageSize: {
                need_check: limitSessions,
                in_check: limitSessions,
                completed: limitSessions,
                posted: limitSessions,
            },
            filter: {
                need_check: initFilter,
                in_check: initFilter,
                completed: initFilter,
                posted: initFilter,
            },
        };
    },
    computed: {
        ...mapGetters('auth', ['userId']),
        ...mapGetters('examination', ['getLoading']),
        tabs() {
            return [
                {
                    name: 'Ожидание',
                    status: 'need_check',
                    visible: true,
                },
                {
                    name: 'В работе',
                    status: 'in_check',
                    visible: true,
                },
                {
                    name: 'Проверено',
                    status: 'completed',
                    visible: true,
                },
                {
                    name: 'Отправлено',
                    status: 'posted',
                    visible: this.isSuper,
                },
            ].filter((row) => row.visible);
        },
        type() {
            return this.$route.params['type'];
        },
        eventId() {
            return +this.$route.params['event'];
        },
        event() {
            const type = this.$store.state.examination.events[this.type];

            return type ? type.items.find(t => t.id === this.eventId) : null;
        },
        name() {
            return this.event ? this.event.name : '';
        },
        breadcrumbs() {
            return [
                { text: 'Кабинет эксперта', path: { name: 'expert-panel' } },
                { text: this.name, path: this.$route.path },
            ];
        },
        block() {
            const type = this.$store.state.examination
                .sessions[this.type];

            if (!type || !type[this.eventId]) return false;

            const inCheck = type[this.eventId]['in_check'];

            const res = inCheck
                && inCheck.total > 2
                && this.tabs[this.currentTab].status === 'need_check';

            return Boolean(res);
        },
        status() {
            return this.$options.tabs[this.currentTab].status;
        },
        dataset() {
            const type = this.$store.state.examination.sessions[this.type];
            if (!type || !this.event) return null;
            return type[this.event.id];
        },
        itemsNew() {
            return this.getItems('need_check');
        },
        itemsNewLoading() {
            return this.getLoading('sessionsneed_check');
        },
        itemsChecking() {
            return this.getItems('in_check');
        },
        itemsCheckingLoading() {
            return this.getLoading('sessionsin_check');
        },
        itemsCompleted() {
            return this.getItems('completed');
        },
        itemsCompletedLoading() {
            return this.getLoading('sessionscompleted');
        },
        itemsPosted() {
            return this.getItems('posted');
        },
        itemsPostedLoading() {
            return this.getLoading('sessionsposted');
        },
        reviewExperts() {
            return this.$store.state.examination.reviewExperts[this.eventId];
        },
        isSuper() {
            const experts = this.reviewExperts;
            if (experts) {
                const expert = experts.find((expert) => expert.userId === this.userId);
                if (expert) {
                    return expert.isSuper;
                }
            }
            return false;
        },
        dateEnd() {
            if (this.event && this.event.endAt) {
                const current = moment();
                const endAt = moment(this.event.endAt);
                const diff = endAt.diff(current, 'minutes');
                const minutes = diff % 60;
                const hours = Math.floor(diff / 60) % 24;
                const days = Math.floor(diff / 60 / 24);
                return [
                    `${days} ${declinationOfNumber(days, 'день', 'дня', 'дней')}`,
                    `${hours} ${declinationOfNumber(hours, 'час', 'часа', 'часов')}`,
                    `${minutes} ${declinationOfNumber(minutes, 'минута', 'минуты', 'минут')}`,
                ].join(' ');
            }
            return '';
        },
    },
    watch: {
        reviewExperts() {
            this.tabs.map(v => v.status).forEach((status) => this.loadData(status, 1, this.currentPageSize[status]));
        },
    },
    methods: {
        getItems(status) {
            if (!this.dataset || !this.dataset[status]) return {
                items: [],
                total: 0,
                needFeedback: 0,
            };
            const currentPage = this.dataset[status].pages[this.currentPage[status]];
            return currentPage ? {
                items: this.mapUsers(currentPage.items),
                total: this.dataset[status].total,
                needFeedback: this.dataset[status].needFeedback,
            } : {
                items: [],
                total: 0,
                needFeedback: 0,
            };

        },
        mapUsers(items) {
            const byId = this.$store.getters['users/byId'];
            return items.map((item) => {
                const user = byId(item.userId);
                if (user) {
                    return {...item, fio: getFio(user), phone: user.tel};
                } else {
                    return {...item};
                }
            });
        },
        loadData(status, page, pageSize = null, filter = {}) {
            this.currentPage[status] = page;
            this.filter[status] = filter;
            if (pageSize !== null) {
                this.currentPageSize[status] = pageSize;
            }
            const params = {
                key: this.type,
                event: this.eventId,
                status,
                userId: filter.userId || undefined,
                id: filter.id || undefined,
                onlyNeedFeedback: filter.onlyNeedFeedback || undefined,
                scoreMin: filter.score
                    ? filter.score[0] || undefined
                    : undefined,
                scoreMax: filter.score
                    ? filter.score[1] || undefined
                    : undefined,
                page,
                pageSize: this.currentPageSize[status],
            };

            this.$store.dispatch('examination/loadSessions', params);
        },
        async reloadData() {
            await this.$store.dispatch('examination/unloadSessions');
            this.tabs.map(v => v.status).forEach((status) => this.loadData(status, 1, limitSessions));
        },
    },
    created() {
        this.$store.dispatch('examination/unloadSessions');
        this.$store.dispatch('examination/loadEvents');
        this.$store.dispatch('examination/loadReviewExperts', this.eventId);
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.expert-panel-event {
  main {
    padding: rem(44) rem(156);
    :deep(.breadcrumbs) {
      height: auto;
    }
  }
  &__header {
    display: flex;
    justify-content: space-between;
  }
  &__till {
    text-align: right;
    div:last-child {
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      color: #4663AB;
    }
  }
}
</style>
